<template>
    <v-dialog
            v-model="dialog"
            max-width="600px"
            scrollable
    >
        <template v-slot:activator="{ on:dialog }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on:tooltip }">
                    <v-btn color="blue"
                           dark
                           small
                           fab
                           depressed
                           v-on="{...dialog, ...tooltip}"
                    >
                        <v-icon>mdi-email-multiple</v-icon>
                    </v-btn>
                </template>
                <span>История сообщений</span>
            </v-tooltip>
        </template>

        <v-card class="modal-card">
            <v-card-title class="pa-6">История сообщений</v-card-title>
            <v-card-text class="pa-6" style="height: 400px;">
                <template v-if="messages.length">
                    <div class="message-group" v-for="message in messages" :key="message.id">
                        <div class="message-heading">
                            <div class="message-heading__title">{{ $dayjs(message.created_at).format('DD MMMM YYYY в HH:mm') }}</div>
                        </div>
                        <div class="message-text">{{message.text}}</div>
                    </div>
                </template>
                <div v-else-if="!messages.length && !messagesUpdate" class="text-center">
                    <v-progress-circular indeterminate></v-progress-circular>
                </div>
                <div v-else class="text-center">Сообщения отсутствуют</div>
            </v-card-text>
            <v-card-actions class="px-6 py-5">
                <v-spacer></v-spacer>
                <v-btn depressed dark color="blue-grey" @click="close" min-width="120">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import clientApi from '../api/client.api';

    export default {
        name   : "ClientMessagesShowDialog",
        props  : {
            clientId: {
                required: true,
            }
        },
        data() {
            return {
                dialog: false,
                messages: [],
                messagesUpdate: false
            };
        },
        watch  : {
            dialog(val) {
                if (true === val) {
                    this.messages = [];
                    this.messagesUpdate = false;

                    clientApi.messages(this.clientId).then(({data}) => {
                        this.messages = data.data;
                    }).catch(() => {
                        this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                    }).finally(() => {
                        this.messagesUpdate = true;
                    });
                }
            }
        },
        created() {

        },
        methods: {
            close() {
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>
